<script setup lang="ts"></script>

<template>
  <nav class="h-(--page-header-height) bg-black/50 w-full fixed top-0">
    <div class="container flex justify-between mx-auto">
      <div class="my-auto">
        <UiAriscorpLogo class="size-24" hover />
      </div>
      <ul class="flex list-none my-auto gap-x-8">
        <li><UiPeople class="size-20" /></li>
        <li><UiPeople class="size-20" /></li>
        <li><UiPeople class="size-20" /></li>
        <li><UiPeople class="size-20" /></li>
        <li><UiPeople class="size-20" /></li>
        <li><UiPeople class="size-20" /></li>
      </ul>
      <div></div>
    </div>
  </nav>
</template>
